"use strict";

angular.module("licensure.services").factory("EXAutoNum", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamAutoNums", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getActiveAutoNums: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamAutoNums/AutoNumberActive", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getautonum: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamAutoNums/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (examAutoNum) {

                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/ExamModule/ExamAutoNums/";

                if (!isUndefined(examAutoNum.id)) {
                    method = "PUT";
                    url += examAutoNum.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: examAutoNum
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/ExamModule/ExamAutoNums/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

        };
    }
]);
